webpackJsonp([7],{

/***/ 0:
/*!*********************************!*\
  !*** ./app/pages/home/index.js ***!
  \*********************************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _rx = __webpack_require__(/*! rx */ 1);
	
	var _core = __webpack_require__(/*! @cycle/core */ 14);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _dom = __webpack_require__(/*! @cycle/dom */ 2);
	
	__webpack_require__(/*! ./index.styl */ 378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GITHUB_URL = 'https://github.com/laszlokorte/tams-tools';
	// eslint-disable-next-line max-len
	var GITHUB_BADGE_URL = 'https://camo.githubusercontent.com/365986a132ccd6a44c23a9169022c0b5c890c387/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f7265645f6161303030302e706e67';
	// eslint-disable-next-line max-len
	var GITHUB_BADGE_URL_CANON = 'https://s3.amazonaws.com/github/ribbons/forkme_right_red_aa0000.png';
	
	// The list of links to be shown on the home page
	var COMPONENTS = [{
	  name: 'Karnaugh map editor',
	  url: './kvd-editor.html'
	}, {
	  name: 'Logic expression editor',
	  url: './logic-editor.html'
	}, {
	  name: 'Logic checker',
	  url: './logic-checker.html'
	}, {
	  name: 'LED editor',
	  url: './led-editor.html'
	}, {
	  name: 'FSM editor',
	  url: './fsm-editor.html'
	}, {
	  name: 'Number circle',
	  url: './number-circle.html'
	}];
	
	var home = function home() {
	  return {
	    DOM: _rx.Observable.just((0, _dom.div)([(0, _dom.ul)('.tile-grid', COMPONENTS.map(function (component) {
	      return (0, _dom.li)('.tile-item', (0, _dom.a)('.tile-link', {
	        href: component.url
	      }, component.name));
	    })), (0, _dom.a)({
	      href: GITHUB_URL
	    }, [(0, _dom.img)({
	      src: GITHUB_BADGE_URL,
	      dataset: {
	        canonicalSrc: GITHUB_BADGE_URL_CANON
	      },
	      style: {
	        position: 'absolute',
	        top: 0,
	        right: 0,
	        border: 0
	      },
	      alt: 'Fork me on GitHub'
	    })])]))
	  };
	};
	
	var drivers = {
	  DOM: (0, _dom.makeDOMDriver)('#app')
	};
	
	_core2.default.run(home, drivers);

/***/ },

/***/ 378:
/*!***********************************!*\
  !*** ./app/pages/home/index.styl ***!
  \***********************************/
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }

});


/** WEBPACK FOOTER **
 ** home-3cf66522f22be8da0286.js
 **/